import {type LocationIdType} from '../../../store/state/locations/state'
import {type NodeDataMap} from '../../../values/nodes/NodeData'
import {type ListOfAssociatedAssets} from './types/usb-devices-response'

import {type TimestampFilter} from '../../../store/state/usb-inventory-filter/state'

export function getListOfVesselsForGivenAssets(
    listOfAssociatedAssets: ListOfAssociatedAssets[] | undefined,
    nodes: NodeDataMap,
): LocationIdType[] {
    let listOfLocationsIds: LocationIdType[] = []
    if (!listOfAssociatedAssets) {
        return listOfLocationsIds
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    listOfLocationsIds = listOfAssociatedAssets?.map(
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (element) => nodes?.get(element.identity)?.location ?? '',
    )
    const uniqueLocationIds = [...new Set(listOfLocationsIds)]
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return uniqueLocationIds.filter((element) => element !== '') ?? []
}

export function formatTimestampCriteria(searchedTimestamp: TimestampFilter): string | null {
    switch (searchedTimestamp) {
        case 'Last 24h':
            return '-24h'
        case 'Last 7 days':
            return '-168h'
        case 'Last 30 days':
            return '-720h'
        case 'All':
        default:
            return null
    }
}

export function reformatTimestampCriteria(searchedTimestamp: string | null): TimestampFilter {
    switch (searchedTimestamp) {
        case '-24h':
            return 'Last 24h'
        case '-168h':
            return 'Last 7 days'
        case '-720h':
            return 'Last 30 days'
        default:
            return 'All'
    }
}
